module.exports = __webpack_public_path__ + "static/desktop_26-51888b03d6b5d7997f72a4e57237c2f5.png";